
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/chats",
      function () {
        return require("private-next-pages/agents/chats.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/chats"])
      });
    }
  